import {defineCustomElement} from 'custom-extensions/ui-utils';
import {html, nothing, LitElement} from 'lit';
import stylesheet from './x-media-card.scss?as=stylesheet';
import {classMap} from 'lit/directives/class-map.js';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';

export class MediaCardComponent extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			blurb: {
				type: String
			},
			ctaText: {
				attribute: 'cta-text',
				type: String
			},
			imageUrl: {
				attribute: 'image-url',
				type: String
			},
			name: {
				type: String
			},
			type: {
				type: String
			},
			url: {
				type: String
			}
		};
	}

	constructor () {
		super();

		/**
		 * @type {string}
		 */
		this.blurb = '';

		/**
		 * @type {string}
		 */
		this.ctaText = '';

		/**
		 * @type {string}
		 */
		this.imageUrl = '';

		/**
		 * @type {string}
		 */
		this.name = '';

		/**
		 * @type {string}
		 */
		this.type = '';

		/**
		 * @type {string}
		 */
		this.url = '';
	}

	render () {
		const cardTypeClass = `card--${this.type}`;
		const classes = {
			card: true,
			[cardTypeClass]: true
		};
		let ctaText = this.ctaText;
		if (!ctaText) {
			ctaText = this.type === 'video' ? 'Watch Now' : 'Read More';
		}

		return html`
			<div class="${classMap(classes)}">
				<a class="card-inner" href="${this.url}">
					<div class="card-image">
						<x-image class="x-media-card-image" src="${this.imageUrl}" alt="${this.name} image"></x-image>
					</div>
					<div class="card-details">
						<div class="card-title">
							${this.name}
						</div>
						${this.renderBlurb()}
						<div class="card-cta">
							<span class="card-cta-text">
								${ctaText}
							</span>
							<span class="card-cta-icon" aria-hidden="true"></span>
						</div>
					</div>
				</a>
			</div>
		`;
	}

	renderBlurb () {
		if (!this.blurb) {
			return nothing;
		}

		return html`
			<div class="card-blurb">${unsafeHTML(this.blurb)}</div>
		`;
	}
};

defineCustomElement('x-media-card', MediaCardComponent);
